module.exports = __webpack_public_path__ + "img/certTJ4.77ddbff7.jpg";